import { Button } from "@/components/ui/button";
import { ColorPicker } from "@/components/ui/color-picker";
import { useResolve } from "@/tsyringe-hooks/useResolve";
import { UndoIcon, RedoIcon } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { TOKEN_TopNavQuickActionsStore, TopNavQuickActionsStore } from "./TopNavQuickActionsStore";

const TopNavQuickActionsView = observer(() => {
    const { t } = useTranslation();
    const store = useResolve<TopNavQuickActionsStore>(TOKEN_TopNavQuickActionsStore);

    return (
        <div className="flex items-center gap-2">
            {store.isInHistoryMode && <Button onClick={store.stopReplay}>
                {t('stop_history')}
            </Button>}
            {!store.isUIReadOnly && <Button disabled={!store.showUndo} variant='ghost' size="icon" leftIcon={<UndoIcon />} onClick={store.undo} title={t('undo')}></Button>}
            {!store.isUIReadOnly && <Button disabled={!store.showRedo} variant='ghost' size="icon" leftIcon={<RedoIcon />} onClick={store.redo} title={t('redo')}></Button>}
            {!store.isUIReadOnly && <ColorPicker
                onChange={store.colorPickerOnChange}
                value={store.colorPickerValue}
            />}
        </div>
    );
});

export default TopNavQuickActionsView;